import { render, staticRenderFns } from "./ChildContentDetailPage.vue?vue&type=template&id=322cd51b&"
import script from "./ChildContentDetailPage.vue?vue&type=script&lang=js&"
export * from "./ChildContentDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports